const useReassingModal = () => {
  return {

    container: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 500,
      bgcolor: "background.paper",
      boxShadow: 24,
      borderRadius: 2,
      p: 5,
    },
    icon: {
      fontSize: "1.2rem",
      mr: 1
    },
    text: {
      color: "#007BFF"
    },
    button: {
      backgroundColor: "#4A01C4",
      padding: "1rem 1.5rem",
    }
  }
}

export { useReassingModal }
